import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Settings } from '../models/Settings';
import { FoodPortalService } from '../services/food-portal.service';
import { Allergen } from '../models/allergen-values.model';

@Component({
    selector: 'pi-allergies-menu',
    templateUrl: './allergen-menu.component.html',
    styleUrls: ['./allergen-menu.scss'],
    standalone: false
})
export class AllergenMenuComponent implements OnInit {

  @Input() settings: Settings;
  showMenu = false;
  allAllergens: Array<Allergen>;
  @HostBinding('class.any-selected') hostClass = true;

  constructor(
    private state: FoodPortalService
  ) { }

  ngOnInit() {
    this.allAllergens = this.state.allergenListV2
      .filter(x => x.major);
  }

  public hideMenu() {
    this.showMenu = !this.showMenu;
  }

  toggleAllergy(allergenName: string) {

    const allergen = this.allAllergens.find(x => x.name === allergenName);
    const idx = this.state.selectedAllergens.indexOf(allergen);

    if (idx !== -1) {
      this.state.selectedAllergens.splice(idx, 1);
    } else {
      this.state.selectedAllergens.push(allergen);
    }

  }

  allergySelected(allergenName: string) {
    const allergen = this.allAllergens.find(x => x.name === allergenName);
    return this.state.selectedAllergens.includes(allergen);
  }


  clearAllergies() {
    this.state.selectedAllergens = [];
    this.showMenu = false;
  }

  anySelected(): boolean {
    return !!this.state.selectedAllergens.length;
  }


}
